import { render, staticRenderFns } from "./SiteBreadcrumb.vue?vue&type=template&id=3c1d2286&scoped=true&"
import script from "./SiteBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./SiteBreadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./SiteBreadcrumb.vue?vue&type=style&index=0&id=3c1d2286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d2286",
  null
  
)

export default component.exports